<template>
  <div class="col-12 col-md-12 col-lg-10">
    <div class="tit text-center">
      <p>{{stepTitle}}</p>
     <button  type="button" class="btn btn-lg btn-link" @click="showPartnerType = true"><span class="icon icon-plus-circle"></span> Adicionar sócio</button>
    </div>
    
    <div class="row justify-content-center">
      <div class="col-12 col-md-12 col-lg-11 col-xl-11">
        <form @submit="onSubmit">
          <div class="form-row" v-for="(socio, index) in socios" :key="`partnerFields${index}`">
            <div class="col-md-11">
              <company-fields v-if="socio.Tipo == 2" :partner="socio" />
              <person-fields v-else :partner="socio" />
            </div>
            <div class="form-group col-md-1 align-self-center text-center">
              <a v-if="!isMei" @click="removePartner(index)" title="Remover sócio" class="icon icon-minus-circle remove"></a>
            </div>
          </div>
          <div class="btns text-center">
            <button v-if="!isMei" type="button" class="btn btn-lg btn-link" @click="showPartnerType = true"><span class="icon icon-plus-circle"></span> Adicionar sócio</button>

            <at-select v-if="showPartnerType" size="large" placeholder="Tipo de Sócio" @on-change="addPartner">
              <at-option value="1">Pessoa Física</at-option>
              <at-option value="2">Pessoa Jurídica</at-option>
            </at-select>
            <div class="text-center fixedOptions">
              <button class="btn btn-lg btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Masker from "@/utils/masker";
import ArrayHelper from "@/utils/array-helper";
import PersonFields from "@/components/AdditionalInformationPeerToPeer/PartnersStep/PersonFields";
import CompanyFields from "@/components/AdditionalInformationPeerToPeer/PartnersStep/CompanyFields";

const COMPANY_TYPE_MEI = 1;

export default {
  components: { PersonFields, CompanyFields },
  data() {
    var partners = this.solicitacao.Empresa.Socios || [];
    return {
      showPartnerType: false,
      socios: partners.map(partner => {
        return {
          Tipo: partner.Tipo,
          Nome: partner.Nome,
          Cpf: partner.Cpf,
          DataNascimento: partner.DataNascimento
            ? new Date(partner.DataNascimento).toLocaleDateString("pt-BR")
            : null,
          Escolaridade: partner.Escolaridade,
          EstadoCivil: partner.EstadoCivil,
          Celular: partner.Celular,
          Email: partner.Email,
          Site: partner.Site,
          Facebook: partner.Facebook,
          Linkedin: partner.Linkedin,
          NomeConjuge: partner.NomeConjuge,
          CpfConjuge: partner.CpfConjuge,
          DataNascimentoConjuge: partner.DataNascimentoConjuge
            ? new Date(partner.DataNascimentoConjuge).toLocaleDateString(
                "pt-BR"
              )
            : null,
          CelularConjuge: partner.CelularConjuge,
          EmailConjuge: partner.EmailConjuge,
          EscolaridadeConjuge: partner.EscolaridadeConjuge,
          RazaoSocial: partner.RazaoSocial,
          Cnpj: partner.Cnpj
        };
      }),
      isMei: this.solicitacao.Empresa.TipoEmpresa == COMPANY_TYPE_MEI,
      errors: []
    };
  },
  props: {
    solicitacao: { required: true, type: Object }
  },
  computed: {
    stepTitle: function() {
      if (this.socios.length == 1) {
        return "Os dados do sócio abaixo estão corretos?";
      } else {
        return "Os dados dos sócios abaixo estão corretos?";
      }
    }
  },
  methods: {
    validate() {
      let hasEmptyFields = false;
      Array.forEach(this.socios, partner => {
        if (
          partner.Tipo == 1 &&
          (partner.Nome == null ||
            partner.Cpf == null ||
            partner.Escolaridade == null,
          partner.EstadoCivil == null)
        ) {
          hasEmptyFields = true;
        }
        if (partner.Tipo == 2 && (!partner.RazaoSocial || !partner.Cnpj)) {
          hasEmptyFields = true;
        }
      });

      const errors = hasEmptyFields
        ? [
            "Nessa etapa é obrigatório o preenchimento de todos as informações solicitadas"
          ]
        : [];
      return { isValid: !hasEmptyFields, errors: errors };
    },
    onSubmit(e) {
      e.preventDefault();
      const validation = this.validate();
      if (validation.isValid) {
        const newData = {
          Empresa: {
            Socios: this.socios.map(socio => {
              var dataNascSocio = null;
              var dataNascConjuge = null;

              if (
                socio.DataNascimento !== null &&
                socio.DataNascimento !== undefined
              ) {
                // eslint-disable-next-line
                dataNascSocio = new Date(
                  socio.DataNascimento.replace(
                    /(\d{2})\/(\d{2})\/(\d{4})/,
                    "$3/$2/$1"
                  )
                );
              }

              if (
                socio.DataNascimentoConjuge !== null &&
                socio.DataNascimentoConjuge !== undefined
              ) {
                // eslint-disable-next-line
                dataNascConjuge = new Date(
                  socio.DataNascimentoConjuge.replace(
                    /(\d{2})\/(\d{2})\/(\d{4})/,
                    "$3/$2/$1"
                  )
                );
              }

              if (socio.Tipo == 1) {
                return {
                  Tipo: socio.Tipo,
                  Nome: socio.Nome,
                  DataNascimento: dataNascSocio,
                  Cpf: Masker.unmaskCpf(socio.Cpf),
                  Escolaridade: socio.Escolaridade,
                  EstadoCivil: socio.EstadoCivil,
                  Celular: socio.Celular,
                  Email: socio.Email,
                  Facebook: socio.Facebook,
                  Linkedin: socio.Linkedin,
                  NomeConjuge:
                    socio.EstadoCivil === 2 || socio.EstadoCivil === 5
                      ? socio.NomeConjuge
                      : "",
                  CpfConjuge:
                    socio.EstadoCivil === 2 || socio.EstadoCivil === 5
                      ? socio.CpfConjuge
                      : "",
                  DataNascimentoConjuge:
                    socio.EstadoCivil === 2 || socio.EstadoCivil === 5
                      ? dataNascConjuge
                      : null,

                  CelularConjuge:
                    socio.EstadoCivil === 2 || socio.EstadoCivil === 5
                      ? socio.CelularConjuge
                      : "",

                  EmailConjuge:
                    socio.EstadoCivil === 2 || socio.EstadoCivil === 5
                      ? socio.EmailConjuge
                      : "",

                  EscolaridadeConjuge:
                    socio.EstadoCivil === 2 || socio.EstadoCivil === 5
                      ? socio.EscolaridadeConjuge
                      : 0
                };
              } else {
                return {
                  Tipo: socio.Tipo,
                  RazaoSocial: socio.RazaoSocial,
                  Cnpj: socio.Cnpj,
                  Site: socio.Site,
                  Celular: socio.Celular,
                  Email: socio.Email,
                  Facebook: socio.Facebook,
                  Linkedin: socio.Linkedin
                };
              }
            }),
            Avalistas: this.socios
              .filter(socio => {
                if (socio.EstadoCivil === 2 || socio.EstadoCivil === 5)
                  return true;
                else return false;
              })
              .map(socio => {
                var dataNasc = null;
                var dataNascConjuge = null;

                if (
                  socio.DataNascimento !== null &&
                  socio.DataNascimento !== undefined
                ) {
                  // eslint-disable-next-line
                  dataNasc = new Date(
                    socio.DataNascimento.replace(
                      /(\d{2})\/(\d{2})\/(\d{4})/,
                      "$3/$2/$1"
                    )
                  );
                }

                if (
                  socio.DataNascimentoConjuge !== null &&
                  socio.DataNascimentoConjuge !== undefined
                ) {
                  // eslint-disable-next-line
                  dataNascConjuge = new Date(
                    socio.DataNascimentoConjuge.replace(
                      /(\d{2})\/(\d{2})\/(\d{4})/,
                      "$3/$2/$1"
                    )
                  );
                }

                if (socio.EstadoCivil === 2 || socio.EstadoCivil === 5) {
                  return {
                    Tipo: socio.Tipo,

                    Nome: socio.NomeConjuge,
                    DataNascimento: dataNascConjuge,
                    Cpf: Masker.unmaskCpf(socio.CpfConjuge),
                    EstadoCivil: socio.EstadoCivil,
                    Celular: socio.CelularConjuge,
                    Email: socio.EmailConjuge,
                    Escolaridade: socio.EscolaridadeConjuge,

                    NomeConjuge: socio.Nome,
                    CpfConjuge: Masker.unmaskCpf(socio.Cpf),
                    DataNascimentoConjuge: dataNasc,
                    CelularConjuge: socio.Celular,
                    EmailConjuge: socio.Email,
                    EscolaridadeConjuge: socio.Escolaridade
                  };
                }
              })
          }
        };

        if (newData.Empresa.Socios.length > 0) {
          this.$emit("on-submit", newData);
        } else {
          this.$Notify.error("Por Favor cadastre o sócio(s)");
        }
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: ArrayHelper.toSentence(validation.errors)
        });
      }
    },
    addPartner(partnerType) {
      this.socios.push({ Tipo: Number.parseInt(partnerType) });
      this.showPartnerType = false;
    },
    removePartner(index) {
      this.socios.splice(index, 1);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/PartnersStep.vue